import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";

interface DesktopReactionsControlsItemProps {
  activeIcon: IconType;
  inactiveIcon: IconType;
  currentIcon: IconType | null;
}

interface Emits {
  (e: "toggleActiveIcon", icon: IconType): void;
  (e: "onActiveIconChange"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopReactionsControlsItem',
  props: {
    activeIcon: {},
    inactiveIcon: {},
    currentIcon: {}
  },
  emits: ["toggleActiveIcon", "onActiveIconChange"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const isIconActive = computed(() => props.currentIcon === props.activeIcon);

const appliedIcon = computed(() => {
  if (isIconActive.value) {
    return props.activeIcon;
  }

  return props.inactiveIcon;
});

const showActiveIcon = () => {
  emit("toggleActiveIcon", props.activeIcon);
  emit("onActiveIconChange");
};

const hideActiveIcon = () => {
  emit("toggleActiveIcon", props.inactiveIcon);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "icon-wrapper",
    onMouseleave: hideActiveIcon
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["icon-inner", { isIconActive: isIconActive.value }]),
      onMouseenter: showActiveIcon
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(Icon, { icon: appliedIcon.value }, null, 8, ["icon"])
    ], 34)
  ], 32))
}
}

})